/*! Trekano Upfit OS(TM) — proprietary. Copyright (c) Trekano. All rights reserved.
 *  "Trekano" and "Trekano Upfit OS" are trademarks of Trekano. Unauthorised
 *  copying, scraping or reverse-engineering is prohibited.  info@trekano.com */
/* TREKANO — Van journey stepper: cross-page navigate + on-page scroll + scrollspy.
   Steps not present on the current page navigate (PDP → /pages/build; build → back to the van);
   steps that ARE on the page scroll. Scrollspy runs only where the configurator is rendered.
   Multi-instance: the PDP renders TWO bars (step 1 at top, step 2 above the upfit-CTA box), so
   each [data-trk-stepper] is initialised independently and the init is idempotent (the snippet's
   <script defer> can load twice on the PDP). */
(function () {
  'use strict';

  function initStepper(nav) {
    if (!nav || nav.dataset.trkInit) return;       // idempotent — skip already-bound bars
    nav.dataset.trkInit = '1';

    var buildUrl = nav.dataset.buildUrl || '/pages/build';
    var steps = Array.prototype.slice.call(nav.querySelectorAll('.trk-stepper__step'));

    function vanParam() {
      try { return new URLSearchParams(window.location.search).get('van') || ''; } catch (e) { return ''; }
    }
    function targetFor(key) {
      if (key === 'top') return document.querySelector('.shopify-section--main-product') || document.body;
      if (key === 'configurator') return document.querySelector('.shopify-section--van-configurator') || document.querySelector('.trk-cfg');
      if (key === 'build') return document.querySelector('[id^="trk-cfg-buildit-"]') || document.querySelector('.trk-cfg__buildit') || document.querySelector('[id^="trk-cfg-review-"]') || document.querySelector('.trk-cfg__review');
      return null;
    }
    function headerOffset() {
      var h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      return (isFinite(h) ? h : 0) + 16;
    }
    function scrollToEl(t) {
      var y = window.pageYOffset + t.getBoundingClientRect().top - headerOffset();
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    function go(key) {
      if (key === 'top') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      if (key === 'back') {
        var v = vanParam();
        window.location.href = v ? ('/products/' + encodeURIComponent(v)) : '/collections/vans-in-stock';
        return;
      }
      var t = targetFor(key);
      if (t && t.getClientRects().length) { scrollToEl(t); return; } // on this page → scroll
      window.location.href = buildUrl;                                // not here → go to the build page
    }
    function setActive(key) {
      var idx = steps.map(function (s) { return s.dataset.step; }).indexOf(key);
      if (idx < 0) return;
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        s.classList.toggle('is-done', i < idx);
      });
    }

    steps.forEach(function (s) {
      s.addEventListener('click', function () { go(s.dataset.step); });
      s.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(s.dataset.step); }
      });
    });

    // Scrollspy — only when the configurator is actually on this page (the /pages/build flow).
    var cfg = targetFor('configurator');
    if (cfg) {
      var build = targetFor('build');
      var passedLine = function (el, line) {
        if (!el || !el.getClientRects().length) return false;
        return el.getBoundingClientRect().top <= line;
      };
      var onScroll = function () {
        var line = headerOffset() + 40;
        var key = 'configurator';            // baseline on the build page = step 2
        if (passedLine(build, line)) key = 'build';
        setActive(key);
      };
      onScroll();
      window.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-trk-stepper]'), initStepper);
})();
